import React from "react";
import MainTable from "../../../components/request-table/request-table"

////////////////////////////////////////////////TABLE COLUMN HEADERS SET UP////////////////////////////////////////////////////////////////////////////////////////
const TableData = ({ resetMenu }: any) => {
  return (<MainTable pageTitle="KYC Request History" pageName="history"  resetMenu={resetMenu}/>)
}
export default TableData;
